


























































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import _ from "lodash";
import { Getter } from "vuex-class";
import ThousandNumberInput from "@/components/forms/inputs/ThousandNumberInput.vue";
import BudgetRepository from "@/repositories/socle/BudgetRepository";
import moment from "moment";
import BudgetLeverRepository, {BudgetLever} from "@/repositories/socle/BudgetLeverRepository";
import * as Constants from "@/Constants";
import EventBus from "front-component/EventBus";
import {Budget} from "@/modules/budget/Budget";
import {SocleClient} from "@/modules/Socle";

const components = {
    ThousandNumberInput,
};
interface TabDataCustom {
    id: number|string;
    lever: string;
    quantityDistributedBeforeOuiPubImpact?: number;
    audienceOnArea?: number;
    usefulContactPoint?: number;
    memoIndex?: number;
    storeTraffic?: number;
    trafficIndex?: number;
    budgetExcludingTax?: number;
    isChild?: boolean;
    budgetRecommended?: number;
    budget?: number;
    uuid?: string;
    comment?: string;
    budgetExcludingTaxTotal?: number;
}
@Component({components})
export default class CampaignForm extends Vue {
    public operation: any | null = false;
    public indicators: any = [];
    public results: any = [];
    public loading: boolean = false;
    public totalBudget: number = 0;
    public budgets: any[] = [];
    public activeCollapse: any = [];
    public kpiSocleConfig: any = Constants.kpiSocleConfig;
    public budgetRulesSocleConfig: any = Constants.budgetRulesSocleConfig;
    public imgSrc: string = "";
    public budgetUuidEditing: string = "";
    public budgetValueEditing: number = 0;
    public currentBudgetValue: number = 0;
    public isBudgetChanged: boolean = false;
    public multiBudgets: Budget[] = [];
    public budgetUuid: string = "";

    @Prop(String) public operationUuid!: string | null;
    @Prop(Boolean) public visible!: boolean;
    @Prop() public configSocleData!: SocleClient;

    @Getter("getCurrentOwnerUuid") public ownerUuid!: string;

    @Watch("operationUuid")
    private changeOperation() {
        this.fetchData();
    }

    @Watch("ownerUuid")
    private changeOwner() {
        this.fetchData();
    }

    public mounted() {
        if (!this.operationUuid) {
            return;
        }
        this.fetchData();
    }

    public lineClass(row: any): string {
        return (row.row.id === "lineTotal") ? "lineTotal" : "";
    }

    public getSummaries(param: any) {
        const { columns } = param;
        const sums: any = [];

        columns.forEach((column: any, index: any) => {
            if (index === 0) {
                sums[index] = "Total";
                return;
            }
            switch (column.property) {
                case "usefulContactPoint":
                    sums[index] = Math.round(this.results.TOTAL_NB_PEOPLE_REMEMBERED_CAMPAIGN);
                    break;
                case "memoIndex":
                    sums[index] = Math.round(this.results.TOTAL_MEMORIZATION_COMPENSATION_INDEX);
                    break;
                case "trafficIndex":
                    sums[index] = Math.round(this.results.TOTAL_MEMORIZATION_COMPENSATION);
                    break;
                case "storeTraffic":
                    sums[index] = Math.round(this.results.TOTAL_TRAFFIC);
                    break;
                case "budgetExcludingTax":
                    sums[index] = _.invoke(this.$options.filters, "price", this.totalBudget);
                    break;
                default:
                    sums[index] = "";
            }
        });

        return sums;
    }

    public get tableData() {
        let totalBudget = 0;
        let totalBudgetMedia = 0;
        let tab: TabDataCustom[] = [{
            id: 1,
            lever: _.invoke(this.$options.filters, "trans", "noComparisonAvailable"),
        }];
        if (undefined !== this.results.CATALOG_DISTRIBUTED_QTY_AFTER_OUIPUB) {
            tab = [{
                id: 1,
                lever: _.invoke(this.$options.filters, "trans", "paperCatalog"),
                quantityDistributedBeforeOuiPubImpact: this.results.CATALOG_DISTRIBUTED_QTY_AFTER_OUIPUB,
                audienceOnArea: Math.round(this.results.CATALOG_USEFUL_AUDIENCE),
                usefulContactPoint: Math.round(this.results.CATALOG_NB_PEOPLE_REMEMBERED_CAMPAIGN),
                memoIndex: 100,
                storeTraffic: Math.round(this.results.CATALOG_TRAFFIC),
                trafficIndex: 100,
                budgetExcludingTaxTotal: this.operation.catalogBudget,
            }];
        }

        this.budgetMedia.forEach((budget) => {
            const line: any = {
                id: budget.media,
                lever: _.invoke(this.$options.filters, "trans", budget.media),
                children: [],
                isChild: false,
            };

            budget.levers.forEach((lever) => {
                totalBudgetMedia += lever.budget;
                line.children.push({
                    id: lever.lever.label,
                    lever: {
                        label: _.invoke(this.$options.filters, "trans", lever.lever.label),
                        code: lever.lever.code
                    },
                    quantityDistributedBeforeOuiPubImpact: null,
                    audienceOnArea: this.getValueFromResult(
                        lever.uuid,
                        lever.lever.code,
                        "_USEFUL_AUDIENCE"
                    ),
                    usefulContactPoint: this.getValueFromResult(
                        lever.uuid,
                        lever.lever.code,
                        "_NB_PEOPLE_REMEMBERED_CAMPAIGN"
                    ),
                    memoIndex: this.getValueFromResult(
                        lever.uuid,
                        lever.lever.code,
                        "_MEMORIZATION_COMPENSATION_INDEX"
                    ),
                    storeTraffic: this.getValueFromResult(
                        lever.uuid,
                        lever.lever.code,
                        "_TRAFFIC"
                    ),
                    trafficIndex: this.getValueFromResult(
                        lever.uuid,
                        lever.lever.code,
                        "_MEMORIZATION_COMPENSATION"
                    ),
                    budgetExcludingTax: _.invoke(this.$options.filters, "price", lever.budget),
                    isChild: true,
                    budgetRecommended: lever.budgetRecommended,
                    budget: lever.budget,
                    uuid: lever.uuid,
                    comment: lever.comment,
                    support: lever.support,
                    diffusion: lever.diffusion,
                    format: lever.format,
                });
            });
            tab.push(line);
        });

        totalBudget = totalBudgetMedia + _.get(this.configSocleData, "flatFeesAmount", 0);
        const totals = {
            id: "lineTotal",
            lever: _.invoke(this.$options.filters, "trans", "total"),
            usefulContactPoint: Math.round(this.results.TOTAL_NB_PEOPLE_REMEMBERED_CAMPAIGN),
            memoIndex: Math.round(this.results.TOTAL_MEMORIZATION_COMPENSATION_INDEX),
            trafficIndex: Math.round(this.results.TOTAL_MEMORIZATION_COMPENSATION),
            storeTraffic: Math.round(this.results.TOTAL_TRAFFIC),
            budgetExcludingTax: totalBudgetMedia,
            budgetExcludingTaxTotal: totalBudget,
        };
        tab.push(totals);

        return tab;
    }

    public get budgetMedia() {
        const groupedData = _.groupBy(this.operation.budgetLevers, (budgetLever) => {
            return budgetLever.lever.media.label;
        });
        const aggregatedData = _.map(groupedData, (levers, label) => {
            const totalBudget = _.sumBy(levers, "budget");
            return {
                media: label,
                budget: totalBudget,
                levers
            };
        });
        const sortedData = _.sortBy(aggregatedData, "media");

        return sortedData;
    }

    private fetchData() {
        return new Promise((resolve) => {
            if (!this.ownerUuid || !this.operationUuid)  {
                return;
            }
            this.loading = true;
            const params = {
                filters: {
                    uuid: this.operationUuid,
                    detail: true,
                },
                fields: [
                    "uuid",
                    "label",
                    "validatedAt",
                    "validationDeadline",
                    "updatedBy.displayName",
                    "updatedAt",
                    "catalogBudget",
                    "campaign.uuid",
                    "campaign.label",
                    "campaign.startDate",
                    "campaign.endDate",
                    "campaign.code",
                    "campaign.externalCode",
                    "campaign.pictureBase64",
                    "campaign.formattedWeek",
                    "hierarchyOwner.uuid",
                    "hierarchyOwner.fullName",
                    "hierarchyOwner.corporateName",
                    "hierarchyOwner.dependentStatus",
                    "hierarchyOwner.clientCode1",
                    "budgetLevers.uuid",
                    "budgetLevers.budget",
                    "budgetLevers.budgetRecommended",
                    "budgetLevers.comment",
                    "budgetLevers.support",
                    "budgetLevers.diffusion",
                    "budgetLevers.format",
                    "budgetLevers.lever.uuid",
                    "budgetLevers.lever.label",
                    "budgetLevers.lever.code",
                    "budgetLevers.lever.media.label",
                    "budgetLevers.lever.variable.uuid",
                    "budgetLevers.results.uuid",
                    "budgetLevers.results.label",
                ]
            };
            BudgetRepository.get(params)
                .then((data: object[]) => {
                    this.operation = data[0] as Budget[];
                    this.indicators = _.get(data, "indicators", []);
                    this.results = _.get(data, "results", []);
                    this.loading = false;
                    this.imgSrc = this.operation.campaign.pictureBase64;
                    this.budgetUuid = this.operation.uuid;
                    resolve(this.operation);
                });
        }).then(() => {
            this.getTotalBudget();
            this.getMultipleBudgets();
            this.activeCollapse = this.budgetMedia.map((budget, idx) => idx);
        });
    }

    public getBudgetLeverComment(budgetLever: BudgetLever): string {
        const columns = ["support", "diffusion", "format"];
        const comment = columns.map((col) => _.get(budgetLever, col, "")).filter(Boolean).join(" - ");

        if (comment) {
            return comment;
        }

        return budgetLever.comment as unknown as string;
    }

    public getWarningMessage(): string {
        let message = "";
        if (this.isValidationDeadlinePassed()) {
            const context = { date: moment(this.operation.validationDeadline).format("DD/MM/YYYY") };
            message = _.invoke(this.$options.filters, "trans", "validationDeadlinePassed", "", "", context);
        }
        if (this.isOperationIsValidated()) {
            const context = {
                date: moment(this.operation.updatedAt).format("DD/MM/YYYY"),
                user: this.operation.updatedBy ? this.operation.updatedBy.displayName : "Import"
            };
            message = _.invoke(this.$options.filters, "trans", "operationAlreadyValidated", "", "", context);
        }
        return message;
    }

    public isOperationIsValidated(): boolean {
        return null === this.operation.validatedAt ? false : true;
    }

    public resetBudget(budgetUuid: string, budgetRecommended: number): void {
        if (this.isValidationDeadlinePassed()) {
            return;
        }
        this.$confirm(_.invoke(this.$options.filters, "trans", "confirmResetBudget"))
            .then(() => {
                const socleBudget = _.merge({uuid: budgetUuid, budget: budgetRecommended});
                BudgetLeverRepository.save(socleBudget).then((data: object) => {
                    this.fetchData();
                    EventBus.$emit("budget-status-updated");
                });
            })
            .catch(() => {
                return;
            });
    }

    public emptyBudget(budgetUuid: string): void {
        if (this.isValidationDeadlinePassed()) {
            return;
        }
        this.$confirm(_.invoke(this.$options.filters, "trans", "cancelBudget"))
            .then(() => {
                const socleBudget = _.merge({uuid: budgetUuid, budget: 0});
                BudgetLeverRepository.save(socleBudget).then((data: object) => {
                    this.fetchData();
                    EventBus.$emit("budget-status-updated");
                });
            })
            .catch(() => {
                return;
            })
        ;
    }

    public updateBudgetDetail(uuid: string, budget: number): void {
        this.budgetUuidEditing = uuid;
        this.budgetValueEditing = budget;
        const budgetDetail = _.find(this.operation.budgetLevers, (vle) => {
            return vle.uuid === uuid;
        });
        if (budgetDetail) {
            if (this.currentBudgetValue === 0) {
                this.currentBudgetValue = budgetDetail.budget;
            }
            budgetDetail.budget = budget;
            this.isBudgetChanged = true;
        }
    }

    public validateBudget(): void {
        if (this.isValidationDeadlinePassed()) {
            return;
        }

        this.$confirm(_.invoke(this.$options.filters, "trans", "confirmValidationBudget"))
            .then(() => {
                const socleBudget = {
                    uuid: this.operationUuid,
                    validatedAt: moment().format("YYYY-MM-DD HH:mm:ss"),
                    selected: true
                };

                BudgetRepository.save(socleBudget).then((data: object) => {
                    this.fetchData();
                    EventBus.$emit("budget-status-updated");
                });
                return;
            })
            .catch(() => {
                return;
            })
        ;
    }

    public isValidationDeadlinePassed(): boolean {
        const validationDl = moment(this.operation.validationDeadline).set("hour", 23).set("minute", 59);
        const currentD = moment();

        return validationDl < currentD;
    }

    public getTotalBudget(): any {
        this.totalBudget = 0;
        return _.find(this.budgetMedia, (value: any) => {
            this.totalBudget += value.budget;
        });
    }

    public getValueFromResult(leverUuid: string, label: string, value: any) {
        const lever = _.find(this.results, (resultLine, uuid) => {
            return uuid === leverUuid;
        });

        const result = _.find(lever, (vle, key) => {
            const formattedKey = _.snakeCase(label).toUpperCase() + value;

            return key === formattedKey;
        });

        return Math.round(result ? result : 0);
    }

    public getBudgetFixed(label: string) {
        return _.find(this.configSocleData.levers, (vle) => {
            if (vle.budgetModificationRule === this.budgetRulesSocleConfig.fixed) {
                return vle.lever.code === label;
            }
        });
    }

    public getBudgetAllOrNothing(label: string) {
        return _.find(this.configSocleData.levers, (vle) => {
            if (vle.budgetModificationRule === this.budgetRulesSocleConfig.all_or_nothing) {
                return vle.lever.code === label;
            }
        });
    }

    public closed() {
        this.isBudgetChanged = false;
        const budgetDetail = _.find(this.operation.budgetLevers, (vle) => {
            return vle.uuid === this.budgetUuidEditing;
        });
        if (budgetDetail) {
            budgetDetail.budget = this.currentBudgetValue;
        }
        this.currentBudgetValue = 0;
        this.$emit("closed");
    }

    public restoreBudget(): void {
        const budgetDetail = _.find(this.operation.budgetLevers, (vle) => {
            return vle.uuid === this.budgetUuidEditing;
        });
        if (budgetDetail) {
            budgetDetail.budget = this.currentBudgetValue;
        }
        this.currentBudgetValue = 0;
        this.isBudgetChanged = false;
    }

    public saveBudget(): number {
        this.isBudgetChanged = false;
        this.budgets = [];
        const budgetDetail = _.find(this.operation.budgetLevers, (vle) => {
            return vle.uuid === this.budgetUuidEditing;
        });
        if (budgetDetail) {
            budgetDetail.budget = this.budgetValueEditing;
        }
        this.currentBudgetValue = this.budgetValueEditing;
        this.operation.budgetLevers.forEach((e: any) => {
            this.budgets.push({uuid: e.uuid, budget: e.budget, lever: e.lever});
        });
        const socleBudget = _.merge({uuid: this.budgetUuidEditing, budget: this.budgetValueEditing});
        BudgetLeverRepository.save(socleBudget).then(() => {
            EventBus.$emit("budget-status-updated");
            this.fetchData();
        });

        return budgetDetail.budget;
    }

    public getMultipleBudgets(): void {
        if (!this.operation) {
            return;
        }
        const params = {
            filters: {
                entityFilter: this.operation.hierarchyOwner.uuid,
                campaignUuid: this.operation.campaign.uuid,
            },
            fields: [
                "uuid",
                "label",
            ]
        };
        BudgetRepository.get(params).then((data: any) => {
            this.multiBudgets = data;
        });
    }

    public changeBudget(budgetUuid: string): void {
        if (this.operationUuid && budgetUuid !== this.operationUuid) {
            this.$emit("update-operation-uuid", budgetUuid);
        }
    }
}

